import { Navigate  } from 'react-router-dom';

import { USER_ROLES, URLS } from '../constants/constants';

import {
  MH_Rides,
  MH_Preferences,
  Admins,
  CreateAdmin,
  UpdateAdmin,
  Health_Organizations,
  Create_Health_Organization,
  Update_Health_Organization,
  CreateMultiSiteAdmin,
  UpdateMultiSiteAdmin,
  Transport_Companies,
  Create_Transport_Company,
  Update_Transport_Company,
  HO_Admin_Users,
  HO_CreateUser,
  HO_UpdateUser,
  HO_Preferences,
  HO_Manager_Users,
  CreateRide,
  TC_Preferences,
  TC_Admin_Users,
  TC_CreateUser,
  TC_UpdateUser,
  TC_Manager_Users,
  Driver_Dashboard,
  Driver_Preferences,
  TC_Admin_Drivers,
  CreateDriver,
  UpdateDriver,
  DraftInfo,
  HO_Rides,
  TC_Rides,
  TC_RideDetails,
  HO_RideDetails,
  MH_RideDetails,
  EditRide,
  DriverRideDetails,
  DriverCancelRide,
  HO_Drafts,
  EditDraft,
  Riders,
  RidersImport,
  Create_Rider,
  UpdateRider,
  HO_CreateUser_admin,
  TC_CreateUser_admin,
  TC_Invoices,
  HO_Invoices,
  ENT_Rides,
  Child_Health_Organizations,
  ENT_Admins,
  Create_Child_Health_Organization,
  Update_Child_Health_Organization,
  CreateENTAdmin,
  UberRescheduleRide,
  Codi_Analytics,
} from '../pages';
import RescheduleRide from '../pages/HO_Admin/RescheduleRide/RescheduleRide';
import MH_Reporting_Dashboard from '../pages/MH_Admin/MH_Reporting_Dashboard/MH_Reporting_Dashhoard';
import ENT_Preferences from '../pages/ENT_Admin/ENT_Preferences/ENT_Preferences';
import UpdateENTAdmin from '../pages/ENT_Admin/UpdateAdmin/UpdateAdmin';

export const routesList = {
  [USER_ROLES.SUPER_ADMIN]: [
    { id: 0, path: URLS.RIDES, exact: true, component: MH_Rides },
    { id: 1, path: URLS.RIDE_DETAILS, exact: true, component: MH_RideDetails },
    { id: 2, path: URLS.UBER_RESCHEDULE_RIDE, exact: true, component: UberRescheduleRide },
    {
      id: 3,
      path: URLS.HEALTH_ORGANIZATIONS,
      exact: true,
      component: Health_Organizations,
    },
    {
      id: 4,
      path: URLS.CREATE_HEALTH_ORGANIZATION,
      exact: true,
      component: Create_Health_Organization,
    },
    {
      id: 5,
      path: URLS.EDIT_HEALTH_ORGANIZATION,
      exact: true,
      component: Update_Health_Organization,
    },
    {
      id: 6,
      path: URLS.TRANSPORT_ORGANIZATIONS,
      exact: true,
      component: Transport_Companies,
    },
    {
      id: 7,
      path: URLS.CREATE_TRANSPORT_ORGANIZATION,
      exact: true,
      component: Create_Transport_Company,
    },
    {
      id: 8,
      path: URLS.EDIT_TRANSPORT_ORGANIZATION,
      exact: true,
      component: Update_Transport_Company,
    },
    { id: 9, path: URLS.ADMINS, exact: true, component: Admins },
    { id: 10, path: URLS.CREATE_ADMIN, exact: true, component: CreateAdmin },
    { id: 11, path: URLS.EDIT_ADMIN, exact: true, component: UpdateAdmin },
    { id: 12, path: URLS.RIDERS, exact: true, component: Riders },
    { id: 13, path: URLS.EDIT_RIDER, exact: true, component: UpdateRider },
    { id: 14, path: URLS.PREFERENCES, component: MH_Preferences },
    { id: 21, path: URLS.EDIT_DRIVER, exact: true, component: UpdateDriver },
    {
      id: 15,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    { id: 16, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 19, path: URLS.UBER_RESCHEDULE_RIDE, exact: true, component: UberRescheduleRide },
    { id: 17, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
    { id: 18, path: URLS.REPORTING, component: MH_Reporting_Dashboard },
    { id: 20, path: URLS.CODI, component: Codi_Analytics },

  ],
  [USER_ROLES.DRIVER]: [
    { id: 0, path: URLS.RIDES, exact: true, component: Driver_Dashboard },
    {
      id: 1,
      path: URLS.RIDE_DETAILS,
      exact: true,
      component: DriverRideDetails,
    },
    { id: 2, path: URLS.CANCEL_RIDE, exact: true, component: DriverCancelRide },
    { id: 3, path: URLS.PREFERENCES, component: Driver_Preferences },
    {
      id: 4,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    { id: 5, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 17, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
  ],
  [USER_ROLES.HO_ADMIN]: [
    { id: 0, path: URLS.DRAFTS, exact: true, component: HO_Drafts },
    { id: 1, path: URLS.EDIT_DRAFT, exact: true, component: EditDraft },
    { id: 2, path: URLS.DRAFT_DETAILS, exact: true, component: DraftInfo },
    { id: 3, path: URLS.RIDES, exact: true, component: HO_Rides },
    { id: 4, path: URLS.CREATE_RIDE, exact: true, component: CreateRide },
    { id: 5, path: URLS.RIDE_DETAILS, exact: true, component: HO_RideDetails },
    { id: 6, path: URLS.EDIT_RIDE, exact: true, component: EditRide },
    { id: 18, path: URLS.RESCHEDULE_RIDE, exact: true, component: RescheduleRide },
    { id: 20, path: URLS.UBER_RESCHEDULE_RIDE, exact: true, component: UberRescheduleRide },
    { id: 7, path: URLS.USERS, exact: true, component: HO_Admin_Users },
    { id: 8, path: URLS.CREATE_USER, exact: true, component: HO_CreateUser },
    { id: 9, path: URLS.EDIT_USER, exact: true, component: HO_UpdateUser },
    { id: 10, path: URLS.RIDERS, exact: true, component: Riders },
    { id: 19, path: URLS.RIDERS_IMPORT, exact: true, component: RidersImport },
    { id: 11, path: URLS.CREATE_RIDER, exact: true, component: Create_Rider },
    { id: 12, path: URLS.EDIT_RIDER, exact: true, component: UpdateRider },
    { id: 18, path: URLS.REPORTING, component: MH_Reporting_Dashboard },
    { id: 21, path: URLS.HO_BILLING, exact: true, component: HO_Invoices },
    { id: 22, path: URLS.CODI, component: Codi_Analytics },
    { id: 90, path: URLS.PREFERENCES, component: HO_Preferences },
    {
      id: 14,
      path: URLS.CREATE_ADMIN_USER,
      exact: true,
      component: HO_CreateUser_admin,
    },
    {
      id: 15,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    { id: 16, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 17, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
  ],
  [USER_ROLES.HO_EMPLOYEE]: [
    { id: 0, path: URLS.DRAFTS, exact: true, component: HO_Drafts },
    { id: 1, path: URLS.EDIT_DRAFT, exact: true, component: EditDraft },
    { id: 2, path: URLS.DRAFT_DETAILS, exact: true, component: DraftInfo },
    { id: 3, path: URLS.RIDES, exact: true, component: HO_Rides },
    { id: 4, path: URLS.CREATE_RIDE, exact: true, component: CreateRide },
    { id: 5, path: URLS.RIDE_DETAILS, exact: true, component: HO_RideDetails },
    { id: 6, path: URLS.EDIT_RIDE, exact: true, component: EditRide },
     { id: 19, path: URLS.RESCHEDULE_RIDE, exact: true, component: RescheduleRide },
     { id: 18, path: URLS.RESCHEDULE_RIDE, exact: true, component: EditRide },
     { id: 20, path: URLS.UBER_RESCHEDULE_RIDE, exact: true, component: UberRescheduleRide },
    { id: 7, path: URLS.USERS, exact: true, component: HO_Manager_Users },
    { id: 8, path: URLS.RIDERS, exact: true, component: Riders },
    { id: 9, path: URLS.CREATE_RIDER, exact: true, component: Create_Rider },
    { id: 8, path: URLS.EDIT_RIDER, exact: true, component: UpdateRider },
    { id: 10, path: URLS.PREFERENCES, component: HO_Preferences },
    {
      id: 11,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    { id: 12, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 17, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
  ],

  [USER_ROLES.TC_ADMIN]: [
    { id: 0, path: URLS.RIDES, exact: true, component: TC_Rides },
    { id: 1, path: URLS.RIDE_DETAILS, exact: true, component: TC_RideDetails },
    { id: 2, path: URLS.USERS, exact: true, component: TC_Admin_Users },
    { id: 3, path: URLS.CREATE_USER, exact: true, component: TC_CreateUser },
    { id: 4, path: URLS.EDIT_USER, exact: true, component: TC_UpdateUser },
    { id: 5, path: URLS.DRIVERS, exact: true, component: TC_Admin_Drivers },
    { id: 6, path: URLS.CREATE_DRIVER, exact: true, component: CreateDriver },
    { id: 7, path: URLS.EDIT_DRIVER, exact: true, component: UpdateDriver },
    { id: 8, path: URLS.BILLING, component: TC_Invoices },
    { id: 9, path: URLS.PREFERENCES, component: TC_Preferences },
    {
      id: 10,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    {
      id: 11,
      path: URLS.CREATE_ADMIN_USER,
      exact: true,
      component: TC_CreateUser_admin,
    },
    { id: 12, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 17, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
  ],
  [USER_ROLES.TC_EMPLOYEE]: [
    { id: 0, path: URLS.RIDES, exact: true, component: TC_Rides },
    { id: 1, path: URLS.RIDE_DETAILS, exact: true, component: TC_RideDetails },
    { id: 2, path: URLS.USERS, exact: true, component: TC_Manager_Users },
    { id: 3, path: URLS.DRIVERS, exact: true, component: TC_Admin_Drivers },
    { id: 4, path: URLS.CREATE_DRIVER, exact: true, component: CreateDriver },
    { id: 5, path: URLS.EDIT_DRIVER, exact: true, component: UpdateDriver },
    { id: 6, path: URLS.PREFERENCES, component: TC_Preferences },
    {
      id: 7,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    { id: 8, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 17, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
  ],

  [USER_ROLES.ENTERPRISE_ADMIN]: [
    { id: 0, path: URLS.RIDES, exact: true, component: ENT_Rides },
    { id: 11, path: URLS.HEALTH_ORGANIZATIONS, exact: true, component: Child_Health_Organizations },
    { id: 1, path: URLS.RIDE_DETAILS, exact: true, component: HO_RideDetails },
   {
      id: 13,
      path: URLS.CREATE_HEALTH_ORGANIZATION,
      exact: true,
      component: Create_Child_Health_Organization,
    },
    {
      id:14,
      path: URLS.CREATE_ADMIN,
      exact: true,
      component: CreateENTAdmin,
    },
    { id: 19, path: URLS.CREATE_MULTI_SITE_ADMIN, exact: true, component: CreateMultiSiteAdmin },
    { id: 20, path: URLS.EDIT_MULTI_SITE_ADMIN, exact: true, component: UpdateMultiSiteAdmin },
     { id: 18, path: URLS.REPORTING, component: MH_Reporting_Dashboard },
    {
      id: 14,
      path: URLS.EDIT_HEALTH_ORGANIZATION,
      exact: true,
      component: Update_Child_Health_Organization,
    },
   { id: 9, path: URLS.ADMINS, exact: true, component: ENT_Admins },
   { id: 10, path: URLS.EDIT_ADMIN, exact: true, component: UpdateENTAdmin },
  //  { id: 22, path: URLS.CODI, component: Codi_Analytics },
   { id: 12, path: URLS.PREFERENCES, exact: true, component: ENT_Preferences },
   { id: 15, path: URLS.HO_BILLING, exact: true, component: HO_Invoices },
    { id: 4, path: URLS.RIDERS, exact: true, component: Riders },
    { id: 8, path: URLS.EDIT_RIDER, exact: true, component: UpdateRider },
    {
      id: 7,
      path: URLS.HOME,
      exact: true,
      component: () => <Navigate  to={URLS.RIDES} />,
    },
    { id: 8, component: () => <Navigate  to={URLS.NOT_FOUND} /> },
    { id: 9, path:'*',  component: () => <Navigate  to={URLS.RIDES} />  },
  ],
};
